import {Transaction} from "../lusca-search-api/generated-src";

export enum UATStatus {
  PENDING,
  FAILED,
  TESTING,
  SDE_REVIEW,
  QA_REVIEW,
  FBI_REVIEW,
  PASSED,
  APPROVED,
  BLOCKED,
  RETEST
}

export interface UATProject {
  id: string;
  name: string;
  description: string;
  GLPG: string;
  marketplace: string;
  orderIDs: Transaction[];
  testCases: TestCase[];
  status: UATStatus;
  created_at: Date;
  updated_at: Date;
  due_date: Date;
  owner: string;
}

export interface TestCase {
  name: string;
  status: UATStatus
  order: Transaction
  history: {
    status: UATStatus;
    runDate: Date;
    comments: {
      user: string;
      comment: string
    }[]
  }[]
  comments: {
    user: string;
    comment: string
  }[]
}